import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFreeCancellation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "32px",
	viewBox: "0 -960 960 960",
	width: "32px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M662-60 520-202l46.67-46.67L661-154.33l179.33-179.34L887-286 662-60ZM291.33-284.67l-46.66-46.66L313.33-400l-68.66-68.67 46.66-46.66L360-446.67l68.67-68.66 46.66 46.66L406.67-400l68.66 68.67-46.66 46.66L360-353.33l-68.67 68.66ZM186.67-80q-27 0-46.84-19.83Q120-119.67 120-146.67v-600q0-27 19.83-46.83 19.84-19.83 46.84-19.83h56.66V-880h70v66.67h333.34V-880h70v66.67h56.66q27 0 46.84 19.83Q840-773.67 840-746.67v319.34l-66.67 67v-206.34H186.67v420h294.66L547.67-80h-361Zm0-553.33h586.66v-113.34H186.67v113.34Zm0 0v-113.34 113.34Z" })
});
export default SvgFreeCancellation;
